import Api, { baseURL } from './Api'

const BASE = baseURL('v2')

export default {
  info: () => Api.one(BASE),
}
